import { SidebarContext } from "context/SidebarContext";
import Drawer from "rc-drawer";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FiX } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const MainDrawer = ({ children, product }) => {
  const { toggleDrawer, isDrawerOpen, closeDrawer, windowDimension } =
    useContext(SidebarContext);
  const [isProduct, setIsProduct] = useState(false);
  const drawerRef = useRef(null); // Reference to the drawer element

  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal

  const handleCancelClick = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleConfirmClose = () => {
    setIsModalOpen(false);
    toggleDrawer();
  };

  const handleCancelClose = () => {
    setIsModalOpen(false); // Close the modal without toggling the drawer
  };

  useEffect(() => {
    if (
      location.pathname === "/periodic-hike-airport-time" ||
      location.pathname === "/periodic-hike-hour-time" ||
      location.pathname === "/basic-rate-fixed" ||
      location.pathname === "/basic-rate-hour" ||
      location.pathname === "/basic-rate-day" ||
      location.pathname === "/bookings" ||
      location.pathname === "/vendor"
    ) {
      setIsProduct(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Close drawer when clicking outside, but not inside the drawer
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        // closeDrawer();
      }
    };

    // Add event listener when drawer is open
    if (isDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDrawerOpen, closeDrawer]);

  return (
    <Drawer
      open={isDrawerOpen}
      parent={null}
      level={null}
      placement={"right"}
      width={`${
        windowDimension <= 575 ? "100%" : product || isProduct ? "85%" : "50%"
      }`}
    >
      <button
        onClick={handleCancelClick}
        className="absolute focus:outline-none z-10 text-red-500 hover:bg-red-100 hover:text-gray-700 transition-colors duration-150 bg-white shadow-md mr-4 mt-3 right-0 left-auto w-10 h-10 rounded-full block text-center"
      >
        <FiX className="mx-auto" />
      </button>

      <div
        ref={drawerRef}
        className="flex flex-col w-full h-full justify-between"
      >
        {children}
      </div>
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          style={{ animation: "fade-in 0.3s ease-out" }}
        >
          <div
            className="bg-white dark:bg-gray-600 dark:text-gray-200 p-6 rounded-lg shadow-xl max-w-sm mx-auto"
            style={{
              maxWidth: "400px",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease-in-out",
              transform: "scale(1.05)",
              animation: "fade-in 0.3s ease-out",
            }}
          >
            <h2
              className="font-normal text-gray-600 mb-4 text-center text-lg dark:text-gray-200"
              style={{
                marginBottom: "1rem",
                fontSize: "1.125rem",
              }}
            >
              Are you sure you want to close?
            </h2>

            <div className="flex justify-center items-center col-gap-10 mt-6">
              <span
                onClick={handleCancelClose}
                style={{
                  cursor: "pointer",
                  color: "#ef4444",
                  fontSize: "1.125rem",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                No
              </span>

              <span
                onClick={handleConfirmClose}
                style={{
                  cursor: "pointer",
                  color: "#10B981",
                  fontSize: "1.125rem",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                Yes
              </span>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default React.memo(MainDrawer);
